import { useEffect, useState, type FormEvent } from "react";
import { useForm } from "../useForm";

import InputTextOnly from "../../controls/InputTextOnly";
import { convertToDefEventPara } from "../../../shared/utility";
import SelectMenu from "../../controls/SelectMenu";
import ImportMediaDropzone from "../../importMedia/ImportMediaDropzone";
import type { CustomerGroup, CustomerGroupFormValues } from "../../../types/customerGroups";

const initialFValues: CustomerGroupFormValues = {
  name: "",
  customers: [],
};

interface CustomerGroupFormProps {
  group: CustomerGroup | null;
  actionCall: (values: CustomerGroupFormValues) => void | Promise<void>;
  isEdit: boolean;
}

export default function CustomerGroupForm(props: CustomerGroupFormProps) {
  const { group, actionCall, isEdit } = props;

  const validate = (fieldValues: Partial<CustomerGroupFormValues> = values) => {
    let temp = { ...errors };

    temp.name = null;
    if (values.name === "") {
      temp.name = "Please give the group a name.";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } = useForm(
    initialFValues,
    false
  );

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (validate()) {
      actionCall(values);
    }
  };

  useEffect(() => {
    if (group) {
      setValues({ ...values, ...group });
    }
  }, [group, setValues]);

  const [logoImage1, setLogoImage1] = useState<string | null>(null);

  return (
    <form onSubmit={handleSubmit}>
      <div className="p-4">
        <div className="space-y-3">
          <div>
            <div className="grid grid-cols-1 gap-4 max-w-4xl">
              <InputTextOnly
                label="Group Name"
                name="name"
                onChange={handleInputChange}
                value={values.name}
                labelOn={true}
                error={errors.name ?? undefined}
              />
              <div className="max-w-40">
                <div className="flex space-x-2">
                  <label htmlFor="image1" className="block text-sm font-medium text-gray-900">
                    Group image
                  </label>
                </div>
                {logoImage1 ? (
                  <div>
                    <img src={logoImage1} height="140" width="140" alt="New logo" />
                  </div>
                ) : isEdit && values.image1 ? (
                  <img
                    src={typeof values.image1 === "string" ? values.image1 : undefined}
                    alt={typeof values.image1 === "string" ? values.image1 : "Customer group"}
                    title={typeof values.image1 === "string" ? values.image1 : undefined}
                    className="media-image rounded-md"
                    height="140"
                    width="140"
                  />
                ) : null}
                <ImportMediaDropzone
                  fileName="image1"
                  handleInputChange={handleInputChange}
                  setUploadedImage={setLogoImage1}
                />
              </div>
            </div>
          </div>

          <div className="sm:flex-no-wrap">
            <div className="my-auto flex items-center">
              <button
                type="submit"
                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-main-purple hover:bg-indigo-700 items-center mt-3"
              >
                {isEdit ? "Save" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
